module.exports = __webpack_public_path__ + "img/move.1866a944.svg";